<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="应付结算单"
  >
    <div class="dialog-content">
      <sirui-search
        ref="storeDataSearch"
        :query="query"
        :columns="searchFormColumns"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></sirui-search>
      <div class="main-content">
        <vxe-table
          ref="siruiTable"
          height="300"
          border
          show-overflow
          :loading="load"
          :data="tableData"
          :showToolbar="false"
          :customVisible="false"
          :auto-resize="true"
          :columns="columnList"
          :footerMethod="footerMethod"
          show-footer
          :edit-rules="validRules"
          :valid-config="{ autoPos: true, message: 'inline' }"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
          @edit-closed="closeEditTableHandler"
        >
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
            :edit-render="item.editRender"
          >
            <template v-slot:edit="{ row }">
              <inputNumberAd
                v-model="row[item.field]"
                v-if="item.editRender.name == 'amountRound'"
                :controls="false"
                class="inputWidth"
                :min="0"
                :max="99999999999999999"
                :precision="2"
                @input="(e) => handleChange(row, item.field)"
              ></inputNumberAd>
            </template>
            <template v-slot="{ row }">
              <template v-if="item.field === 'settlementBusinessType'">{{
                businessCategory?.find((item) => item.value == row['settlementBusinessType'])?.label
              }}</template>
              <template v-else-if="item.field === 'settlementStatus'">{{
                settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
              }}</template>
              <template v-else-if="item.field === 'paymentStatus'">{{
                pay_paymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
              }}</template>

              <template v-else-if="item.field === 'printFlag'">{{
                row.printFlag == 1 ? '已打印' : '未打印'
              }}</template>
              <!-- <template v-else-if="item.field === 'businessCategory'">{{
              getSettlementBusinessTypeStatus(row.businessCategory)
            }}</template> -->
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </vxe-table>
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handlePagination"
          :page-count="page.pages"
          :current-page="page.pageNum || 1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="relatedHandler"
          >确定关联</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  // , tableList
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';

  export default {
    props: {},
    data() {
      return {
        load: false,
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        columnList: defaultTableColumn,
        query: {
          // settlementCompanyNo: '',
          // settlementDepartmentNo: '',
          // settlementStatus: '',
          supplierNo: '',
          contractNoStr: '',
          // settlementType: '1',
          payableSettlementNo: '',
          supplierName: '',
        },
        page: {
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        companyCode: null,
        visible: false,
        preSettlements: [], //行上已经有的数据
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      pay_paymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
      //校验
      validRules() {
        const amountValid = (rule, value, callback, { row }) => {
          console.log(rule, value);
          //冲销数量≤结算数量
          if (row.writeOffPreNum > row.settlementQuantity) {
            callback(new Error('冲销数量≤结算数量'));
          } else {
            callback();
          }
        };
        return {
          writeOffPreNum: [
            // {
            //   required: true,
            //   message: '冲销数量必填',
            // },
            { validator: amountValid, trigger: 'blur' },
          ],
        };
      },
    },
    mounted() {
      // this.getTableData();
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['writeOffPreNum'].includes(column.property)) {
              return Number(data.reduce((cur, next) => cur + +next.writeOffPreNum, 0).toFixed(2));
            }
            return null;
          }),
        ];
      },
      handleChange() {},
      async closeEditTableHandler() {
        console.log('关闭');
      },
      openDialog(preSettlements) {
        if (preSettlements.length) {
          this.preSettlements = preSettlements;
        }
        this.visible = true;
        this.getTableData(this.page.pageNum, this.page.pageSize);
      },
      // 点击分页
      handlePagination(val) {
        this.page.pageNum = val;
        this.getTableData(this.page.pageNum, this.page.pageSize);
      },
      // 获取表格数据
      async getTableData(pageNum = 1, pageSize = 10) {
        console.log('搜索');
        const postData = {
          ...this.query,
          pageNum,
          pageSize,
        };
        // this.$refs.siruiTable.page.pageNum,
        // this.$refs.siruiTable.page.pageSize,
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.RELATED_PAYBLES_SETTLEMENT_API,
          postData
        );
        this.tableData = data?.data?.records.map((item) => {
          return {
            ...item,
            writeOffPreNumTemp: item.writeOffPreNum, //临时存储剩余可冲销数量，用于后续比较
          };
          // if (this.preSettlements.length) {
          //   this.preSettlements.map((item1) => {
          //     if (item1.payableSettlementNo == item.payableSettlementNo) {
          //       item.writeOffPreNum = item1.writeOffPreNum;
          //     }
          //   });
          // }
          // return item;
        });
        this.page.total = data?.data?.total;
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row.selection;
      },
      //确认关联
      relatedHandler() {
        console.log(this.multipleSelection, 'this.multipleSelection');
        if (!this.multipleSelection.length) {
          this.$message.error('请选择行操作！');
          return;
        }
        let validAmout = false;
        let zeroAmount = false;
        let writeAmout = false;
        this.multipleSelection.forEach((item) => {
          if (item.writeOffPreNum == 0) {
            zeroAmount = true;
          }
          if (item.writeOffPreNum > item.settlementQuantity) {
            validAmout = true;
          }
          if (item.writeOffPreNum > item.writeOffPreNumTemp) {
            writeAmout = true;
          }
        });
        if (zeroAmount) {
          return this.$message.error('冲销数量必填');
        }
        if (writeAmout) {
          return this.$message.error('冲销数量不能大于剩余可冲销数量');
        }
        if (validAmout) {
          return this.$message.error('冲销数量必须≤结算数量，请检查');
        }
        this.$emit('relatedHandler', this.multipleSelection);
        this.visible = false;
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        // this.$refs.siruiTable.setPageNum(1);
        this.page.pageNum = 1;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData(1, this.page.pageSize);
      },
      // 重置
      resetBtnClickHandler() {
        // this.$refs.siruiTable.setPageNum(1);
        // this.$refs.siruiTable.setPageSize(10);
        this.page.pageNum = 1;
        this.page.pageSize = 10;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange(val) {
        // this.$refs.siruiTable.setPageNum(1);
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.getTableData(1, this.page.pageSize);
      },
      // 修改当前页
      // handleCurrentChange() {
      //   this.getTableData(this.page.pageNum, this.page.pageSize);
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
</style>
